
import { defineComponent } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import axios from "@/axios-instance";

export default defineComponent({
  name: "rescore-drawer",
  emits: ["saved"],
  data() {
    return {
      show: false, loading: false, checking: false, applying: false,
      sheet: null as any, //phiếu điểm từ BE (GET /admission/passed/rescore/:id)
      vals: {} as any,    //điểm đang nhập theo subKey
      review: null as any, //kết quả xét tuyển lại — đổi input là phải xét lại
      reason: '',          //lý do thu hồi khi rớt chuẩn
    }
  },
  methods: {
    //id = winner id HOẶC adreg id (BE tự phân giải)
    async open(id: string) {
      this.show = true; this.loading = true
      this.sheet = null; this.vals = {}; this.review = null; this.reason = ''
      this.checking = false; this.applying = false
      try {
        const { data } = await axios.get(`/admission/passed/rescore/${id}`)
        const vals: any = {}
        for (const s of data.subjects) {
          vals[s.key] = data.method === 1 ? { c10: s.cur.c10, c11: s.cur.c11, c12: s.cur.c12 } : { score: s.cur.score }
        }
        this.sheet = data
        this.vals = vals
      } catch (err: any) {
        this.show = false
        Swal.fire({ text: err?.response?.data?.errorMessage || 'Không tải được phiếu điểm.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
      }
      this.loading = false
    },
    //đổ điểm gốc của ứng viên (students) vào các ô — dùng khi điểm gốc đã import từ Bộ là bản đúng
    fillFromBase() {
      if (!this.sheet) return
      for (const s of this.sheet.subjects) {
        if (this.sheet.method === 1) {
          for (const k of ['c10', 'c11', 'c12']) {
            if (s.base[k] !== null && s.base[k] !== undefined && s.base[k] !== '') this.vals[s.key][k] = s.base[k]
          }
        } else if (s.base.score !== null && s.base.score !== undefined && s.base.score !== '') {
          this.vals[s.key].score = s.base.score
        }
      }
      this.review = null
    },
    //bước 1: XÉT TUYỂN LẠI (mode review — chưa ghi gì): BE tính tổng theo quy chế + so điểm chuẩn
    async runReview() {
      this.checking = true
      await axios.post('/admission/passed/rescore', { id: this.sheet.winner.id, mode: 'review', scores: this.vals })
        .then(({ data }) => { this.review = data })
        .catch(({ response }) => {
          Swal.fire({ text: response?.data?.errorMessage || 'Xét tuyển lại thất bại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        })
      this.checking = false
    },
    //bước 2: ÁP DỤNG — đạt chuẩn thì chỉ cập nhật điểm; rớt chuẩn thì BẮT BUỘC kèm thu hồi QĐ (đã nhập lý do)
    async runApply() {
      const rv = this.review
      if (!rv) return
      const willRevoke = rv.passed === false
      const { isConfirmed } = await Swal.fire({
        html: willRevoke
          ? `Điểm mới <b>KHÔNG ĐẠT</b> điểm chuẩn.<br/>Hệ sẽ cập nhật điểm <b>và THU HỒI QĐ trúng tuyển</b> (giữ vết + lý do). Tiếp tục?`
          : `Cập nhật điểm hồ sơ, điểm gốc ứng viên và tính lại tổng điểm xét. Tiếp tục?`,
        icon: willRevoke ? 'warning' : 'question', showCancelButton: true, buttonsStyling: false,
        confirmButtonText: willRevoke ? 'Cập nhật & Thu hồi' : 'Cập nhật', cancelButtonText: 'Trở lại',
        customClass: { confirmButton: willRevoke ? 'btn btn-danger' : 'btn btn-primary', cancelButton: 'btn btn-light' },
      })
      if (!isConfirmed) return
      this.applying = true
      await axios.post('/admission/passed/rescore', {
        id: this.sheet.winner.id, mode: 'apply', scores: this.vals,
        revoke: willRevoke, reason: this.reason.trim(),
      })
        .then(({ data }) => {
          const nvTxt = (data.nvUpdated || []).map((n: any) => `NV${n.nv} ${n.adForm}: ${n.avg}`).join(' · ')
          Swal.fire({
            html: (data.revoked
              ? `Đã cập nhật điểm và <b>THU HỒI QĐ trúng tuyển</b>.<div class="fs-7 text-muted mt-1">Hồ sơ đã về TRƯỚC thẩm định (mở khóa) — kiểm tra lại rồi thẩm định + xét lại nếu cần.</div>`
              : `Đã cập nhật điểm — hồ sơ <b>vẫn ĐẠT</b> điểm chuẩn.`) + (nvTxt ? `<div class="fs-7 text-muted mt-2">${nvTxt}</div>` : ''),
            icon: 'success', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
          this.show = false
          this.$emit('saved')
        })
        .catch(({ response }) => {
          Swal.fire({ text: response?.data?.errorMessage || 'Cập nhật thất bại.', icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' } })
        })
      this.applying = false
    },
  },
});
